export enum Theme {
    LightTheme = 'LightTheme',
    DarkTheme = 'DarkTheme',
}
